import { PROVIDER_CASINO } from '~/constants/casino'

export const casinoCategories = [
  { label: 'Tất cả thể loại', icon: 'icon-all', value: '' },
  { label: 'Sicbo', icon: 'icon-sicbo', value: 'sic-bo' },
  { label: 'Baccarat', icon: 'icon-baccarat', value: 'baccarat' },
  { label: 'Roulette', icon: 'icon-roulette', value: 'roulette' },
  { label: 'Fan Tan', icon: 'icon-fan-tan', value: 'fan-tan' },
  { label: 'Game Show', icon: 'icon-game-show', value: 'game-show' },
  { label: 'Dragon Tiger', icon: 'icon-dragon-tiger', value: 'dragontiger' },
  { label: 'Poker', icon: 'icon-poker', value: 'poker' },
  { label: 'Blackjack', icon: 'icon-black-jack', value: 'blackjack' },
  { label: "Casino Hold'em", icon: 'icon-casino-holdem', value: 'casino-holdem' },
  { label: 'Table Game', icon: 'icon-table-game', value: 'table-games' }
]

export const casinoProviders = [
  {
    value: '',
    label: 'Tất Cả',
    icon: '/assets/images/icons/provider/all.png',
    iconGray: '/assets/images/icons/provider/all-gray.webp'
  },
  {
    value: PROVIDER_CASINO.EVOLUTION_GAMING,
    label: 'Evolution',
    icon: '/assets/images/icons/provider/evolution.webp',
    iconGray: '/assets/images/icons/provider/evolution-gray.webp'
  },
  {
    value: PROVIDER_CASINO.HIT_CLUB,
    label: 'HitClub',
    icon: '/assets/images/icons/provider/hitclub.webp',
    iconGray: '/assets/images/icons/provider/hitclub-gray.webp'
  },
  {
    value: PROVIDER_CASINO.RIK_VIP,
    label: 'Rik.Vip',
    icon: '/assets/images/icons/provider/rikvip.webp',
    iconGray: '/assets/images/icons/provider/rikvip-gray.webp'
  },
  {
    value: PROVIDER_CASINO.B52,
    label: 'B52',
    icon: '/assets/images/icons/provider/b52.webp',
    iconGray: '/assets/images/icons/provider/b52-gray.webp'
  },
  {
    value: PROVIDER_CASINO.VIVO_GAMING,
    label: 'Vivo Gaming',
    icon: '/assets/images/icons/provider/vivo.webp',
    iconGray: '/assets/images/icons/provider/vivo-gray.webp'
  },
  {
    value: PROVIDER_CASINO.EBET,
    label: 'Ebet',
    icon: '/assets/images/icons/provider/ebet.webp',
    iconGray: '/assets/images/icons/provider/ebet-gray.webp'
  },
  {
    value: PROVIDER_CASINO.EZUGI,
    label: 'Ezugi',
    icon: '/assets/images/icons/provider/ezugi.webp',
    iconGray: '/assets/images/icons/provider/ezugi-gray.webp'
  },
  {
    value: PROVIDER_CASINO.DREAM_GAMING,
    label: 'Dream Gaming',
    icon: '/assets/images/icons/provider/dream.webp',
    iconGray: '/assets/images/icons/provider/dream-gray.webp'
  },
  {
    value: PROVIDER_CASINO.HO_GAMING,
    label: 'Hogaming',
    icon: '/assets/images/icons/provider/hogaming.webp',
    iconGray: '/assets/images/icons/provider/hogaming-gray.webp'
  },
  {
    value: PROVIDER_CASINO.YEE_BET,
    label: 'Yeebet',
    icon: '/assets/images/icons/provider/yeebet.webp',
    iconGray: '/assets/images/icons/provider/yeebet-gray.webp'
  },
  {
    value: PROVIDER_CASINO.PRAGMATIC,
    label: 'Pragmatic',
    icon: '/assets/images/icons/provider/pragmatic.webp',
    iconGray: '/assets/images/icons/provider/pragmatic-gray.webp'
  },
]
